import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-premium-font-settings',
  templateUrl: './premium-font-settings.component.html',
  styleUrls: ['./premium-font-settings.component.css']
})
export class PremiumFontSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
